import { Component, ElementRef, ViewChild } from '@angular/core';
import {LayoutService} from "./service/app.layout.service";
import { AdminUserService } from '../services/admin-user.service';
import { AdminUser } from '../models/Authentication';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {
    currentAdmin: AdminUser;
    userInitials: string = '';

    @ViewChild('menubutton') menuButton!: ElementRef;

    constructor(public layoutService: LayoutService, private adminUserService: AdminUserService) { }

    ngOnInit() {
        this.adminUserService.getMe()
        .subscribe((user: AdminUser) => {
            this.currentAdmin = user;
            if (this.currentAdmin.name) {
                const nameParts = this.currentAdmin.name.split(' ');
                this.userInitials = nameParts.map(part => part.charAt(0)).join('');
            }
        });
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }
    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

}
